module.exports = __webpack_public_path__ + "img/1821844087883360.084d186d.jpg";